export const sideNavigationProps = [
  {
    id: 'additionalExercises',
    titleText: 'Activities.SideNavigation.AdditionalExercises',
    type: 'additional',
  },
  {
    id: 'cards',
    titleText: 'Activities.SideNavigation.Cards',
    type: 'card_form_activity',
  },
  { id: 'videos', titleText: 'Activities.SideNavigation.Videos' },
  {
    id: 'literature',
    titleText: 'Activities.SideNavigation.Literature',
  },
  { id: 'articles', titleText: 'Activities.SideNavigation.Articles' },
  { id: 'seeMore', titleText: 'Activities.SideNavigation.SeeMore' },
];
